import assignmentHelpDirectory from "./assignmentHelpDirectory.json";
import { normalizeInternalHref } from "../utils/routes";

export interface AssignmentHelpCategoryLink {
  label: string;
  href: string;
  slug: string;
}

export interface AssignmentHelpCategory {
  title: string;
  description: string;
  cta: string;
  links: AssignmentHelpCategoryLink[];
}

export const assignmentCategories = (
  assignmentHelpDirectory as AssignmentHelpCategory[]
).map((category) => ({
  ...category,
  links: category.links.map((link) => ({
    ...link,
    href: normalizeInternalHref(link.href),
  })),
}));
